// src/i18n/agents.ts —— C-09 代理管理（0045：去返佣费率、售价表与代改售价）、C-10 分销用户、C-11 佣金结算、C-12 提佣审核文案包（经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06，其余本计划定稿（W-7 回写）。与 funds 共用的键（stPaying / stVerifyFailed / slaOverdue / cNetAmount / toastMarkPaid / aMarkPaidAgain / errNoteLong / fndApprovedAt）在 i18n/funds.ts
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_AGENTS: I18nPack = {
  zh: {
    // 06 [改写 key]
    tabAgentWd: ['待审核', '待支付', '支付中', '已支付', '验证失败', '已拒绝', '全部'], // C-12（X-34 / S-50 / S-65）
    cContribution: '贡献充值（产生手续费）', // C-10（X-38 / S-52）
    agentEditTip: '编辑只更新资料与绑定用户；如需重置登录密码，请使用「重置登录密码」操作。', // C-09（SP6 TD-18 / G-12；0045 去「费率」）
    toastSettle: '已结算，佣金已计入可提余额', // Toast 映射（X-40）
    // 06 [新增 key]
    levelAutoTip: '层级由上级代理自动决定，当前最多 {max} 级（系统参数可调）', // 用户 2026-10-18：多级代理，默认 10 级、可调 2～100
    bindUserTip: '绑定后该代理可选择『提到平台 USDT 钱包』，佣金入账该用户余额',
    cBoundUser: '绑定用户 UID',
    delAgentText: '删除后其名下用户与下级代理将上移至上级代理（无上级则归平台直属），其 Bot 改挂上级（无上级则归平台），推荐码立即失效且不再复用，平台钱包绑定解除。不可恢复。',
    beneUser: '用户',
    beneAgent: '代理',
    unitCard: '张',
    cNegSum: '负额合计',
    cNegSince: '最早挂账日期',
    negTip: '负额将在后续结算批次中自动抵扣，不会形成负余额',
    tabNegative: '负余额挂账',
    errBindUser: '用户不存在或已绑定其他代理',
    agentWdFailedTip: '链上验证未通过。该笔金额仍计入代理的在途提佣、占用其可提余额（F-10），直至重新登记正确哈希到账或拒绝后释放。',
    // 以下本计划定稿（W-7 回写）
    platformDirect: '平台直属',
    levelAuto: '按上级自动',
    // 多级代理（用户 2026-10-18）：页签只留「全部」+ 层级筛选；统计卡动态层级；上级远程搜索；树逐级下钻
    tabAgentsAll: ['全部'],
    levelSummary: '顶级 {top} · 共 {levels} 级 · 上限 {max} 级',
    cParentSearch: '搜索上级（编号 / 名称 / 账号）',
    parentSearchPh: '输入关键字后自动搜索可作上级的代理',
    parentSearchNone: '未找到可作上级的代理（须在册且层级低于上限）',
    parentSearchHit: '找到 {n} 个候选，请在「上级代理」下拉中选择',
    downlineMore: '仅显示前 {n} 个直接下级，可点击下级继续查看其下级',
    settleFailedN: '{n} 笔失败',
    toastSettleDone: '已结算 {n} 个受益人，共 {settled}',
    errRate: '费率格式不正确（最多 2 位小数）',
    errLoginAccount: '登录账号为 3～32 位小写字母、数字或下划线',
    cEntries: '笔数',
    cId: 'ID',
    ckOpen: '开卡差价', // 06 C-11 类型列 open（0045：代理行为加价差价，旧返佣记录同 kind 文案统一）
    ckTopup: '充值差价', // 06 C-11 类型列 topup（X-06 / 0045）
    ckFxSpread: '汇率差',
    ckOpenUser: '开卡奖励', // 受益人为用户（用户链拉新奖励 l1 / l2，0045 不变）
    ckTopupUser: '充值奖励',
    // 0045 代理加价定价：售价表与代改售价（C-09 抽屉）
    agentPricesTitle: '售价',
    aEditPrices: '代改售价',
    pricesUplineAgent: '上级：{name} · {biz_no}',
    pricesUplinePlatform: '上级：平台（上级价即平台价）',
    pricesTip: '留空 = 沿用上级价；生效价 = max(代理售价, 上级价)；代改不影响其下级',
    pricesParent: '上级价',
    pricesOwn: '代理售价',
    pricesInherit: '继承',
    pricesEarn: '每张赚',
    pricesEarnRate: '费率差',
    pricesDeposit: '充值手续费率（%）',
    priceBelowParentTip: '低于上级售价，已按上级价执行',
    pricesFormTip: '留空 = 沿用上级价。开卡价 ≥ 0、最多 2 位小数；充值费率 0 ≤ r < 100、最多 4 位小数；均不得低于上级价。',
    pricesFieldOpen: '{name} · {bin}（上级 {parent}）',
    pricesFieldDeposit: '充值手续费率 %（上级 {parent}）',
    errPriceFormatOpen: '{label}：请输入不低于 0、最多 2 位小数的价格',
    errPriceFormatRate: '{label}：请输入 0 到 100（不含 100）之间、最多 4 位小数的费率',
    errPriceBelow: '{label}：不能低于上级价 {parent}',
    pricesNoChange: '售价未修改',
    toastPricesSaved: '售价已保存',
    fxHistory: '汇率调价历史', fxHistoryReadOnly: '只读 · 每笔生效价以充值快照为准', fxInherited: '继承平台汇率',
    errAgentName: '代理名称不能为空且不超过 64 字',
    errEmail: '邮箱格式不正确',
    errTelegramId: 'Telegram ID 须为纯数字',
    settleTitle: '确认结算',
    settleAgentText: '将结算代理 {agent} 名下全部待结算佣金，计入可提余额；受益人合计为负时整批挂账。',
    settleAllText: '将结算全部待结算佣金，计入各受益人可提余额；受益人合计为负时整批挂账。',
    fndErrTgUser: 'Telegram 用户名须以 @ 开头',
    fndErrTgIdClear: 'Telegram ID 暂不支持清空，如需更换请填写新 ID',
    fndSourceRef: '来源单据',
    fndBeneficiary: '受益人',
    // 运营 UX 评审 2026-10-15 #13：原型「支付处理」让人以为点了就会付款；实为人工登记已付哈希的兜底入口（rewrites 覆盖原型键）
    aPay: '手工登记已付哈希',
  },
  en: {
    tabAgentWd: ['Pending', 'To pay', 'Paying', 'Paid', 'Verification failed', 'Rejected', 'All'],
    cContribution: 'Top-up contributed (fees)',
    toastSettle: 'Settled — added to withdrawable balance',
    delAgentText: 'Its users and sub-agents move up to its parent (or the platform), its bots move to the parent (or the platform), the referral code is retired and the wallet binding is removed. Irreversible.',
    cNegSum: 'Negative total',
    cNegSince: 'Carried since',
    tabNegative: 'Carried negatives',
    // 以下本计划定稿（06 只给 zh 或未给文案）
    agentEditTip: 'Editing only updates details and the bound user; to reset the login password, use “Reset login password”.',
    levelAutoTip: 'Level follows the upline automatically (currently up to {max} levels, adjustable in settings)',
    bindUserTip: 'Once bound, the agent can withdraw to the platform USDT wallet; commissions are credited to that user’s balance',
    cBoundUser: 'Bound user UID',
    beneUser: 'User',
    beneAgent: 'Agent',
    unitCard: 'card',
    negTip: 'Negative amounts are offset automatically in later settlement batches and never create a negative balance',
    agentWdFailedTip: "On-chain verification failed. The amount still counts as the agent's in-flight withdrawal and holds its withdrawable balance (F-10) until a correct hash is re-recorded and verified, or the request is rejected.",
    platformDirect: 'Platform',
    levelAuto: 'Auto (by upline)',
    tabAgentsAll: ['All'],
    levelSummary: 'Top {top} · {levels} levels · max {max}',
    cParentSearch: 'Search upline (ID / name / account)',
    parentSearchPh: 'Type to search agents that can be an upline',
    parentSearchNone: 'No eligible upline found (must be active and below the max level)',
    parentSearchHit: '{n} candidates found; pick one in the Upline list',
    downlineMore: 'Showing the first {n} direct sub-agents; click one to view its sub-agents',
    settleFailedN: '{n} failed',
    toastSettleDone: 'Settled {n} beneficiaries, {settled} in total',
    errBindUser: 'User not found or already bound to another agent',
    errRate: 'Invalid rate (up to 2 decimals)',
    errLoginAccount: 'Login account: 3–32 lowercase letters, digits or underscores',
    cEntries: 'Entries',
    cId: 'ID',
    ckOpen: 'Card markup',
    ckTopup: 'Top-up markup',
    ckFxSpread: 'FX spread',
    ckOpenUser: 'Card reward',
    ckTopupUser: 'Top-up reward',
    agentPricesTitle: 'Prices',
    aEditPrices: 'Edit prices',
    pricesUplineAgent: 'Upline: {name} · {biz_no}',
    pricesUplinePlatform: 'Upline: platform (platform prices)',
    pricesTip: 'Blank = upline price; effective = max(agent price, upline price); edits do not affect its sub-agents',
    pricesParent: 'Upline',
    pricesOwn: 'Agent price',
    pricesInherit: 'Inherited',
    pricesEarn: 'Earn / card',
    pricesEarnRate: 'Rate spread',
    pricesDeposit: 'Top-up fee rate (%)',
    priceBelowParentTip: "Below the upline's price — upline price applies",
    pricesFormTip: 'Blank = upline price. Card price ≥ 0 with up to 2 decimals; top-up rate 0 ≤ r < 100 with up to 4 decimals; neither may be below the upline.',
    pricesFieldOpen: '{name} · {bin} (upline {parent})',
    pricesFieldDeposit: 'Top-up fee rate % (upline {parent})',
    errPriceFormatOpen: '{label}: enter a price of 0 or more with up to 2 decimals',
    errPriceFormatRate: '{label}: enter a rate from 0 to below 100 with up to 4 decimals',
    errPriceBelow: "{label}: cannot be lower than the upline's {parent}",
    pricesNoChange: 'No price changed',
    toastPricesSaved: 'Prices saved',
    fxHistory: 'Exchange-rate history', fxHistoryReadOnly: 'Read only · credited deposits retain their applied rate', fxInherited: 'Inherit platform rate',
    errAgentName: 'Agent name is required (max 64 chars)',
    errEmail: 'Invalid email address',
    errTelegramId: 'Telegram ID must be digits only',
    settleTitle: 'Confirm settlement',
    settleAgentText: "Settles all unsettled commissions under agent {agent} into the withdrawable balance; a beneficiary whose total is negative is carried over.",
    settleAllText: 'Settles all unsettled commissions into each beneficiary’s withdrawable balance; a beneficiary whose total is negative is carried over.',
    fndErrTgUser: 'Telegram username must start with @',
    fndErrTgIdClear: 'Telegram ID cannot be cleared; enter a new ID to change it',
    fndSourceRef: 'Source',
    fndBeneficiary: 'Beneficiary',
    aPay: 'Record manual payment hash',
  },
};

// 原型键按 06 改写（TD-805）
export const REWRITES_AGENTS: readonly string[] = ['tabAgentWd', 'cContribution', 'agentEditTip', 'toastSettle', 'aPay'];
